var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "orangeT1",
    iconsize: 20,
    className: "Icon-sc-1iwi4w1-0 hPXzJz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.066 16.735a5.886 5.886 0 01-4.193 1.739 5.879 5.879 0 01-4.192-1.74l-6.416-6.41A5.893 5.893 0 011.531 6.13c0-1.584.616-3.074 1.734-4.192a1.386 1.386 0 011.966 0l2.143 2.143a1.386 1.386 0 010 1.965l-.914.914a2.362 2.362 0 000 3.34l3.238 3.244a2.362 2.362 0 003.341 0l.918-.919c.524-.523 1.442-.523 1.966.005l2.143 2.138a1.386 1.386 0 010 1.966zm1.082-3.044l-2.143-2.143a2.921 2.921 0 00-4.13 0l-.914.914a.83.83 0 01-1.18 0L7.538 9.224a.836.836 0 010-1.18l.918-.919c.55-.55.852-1.282.852-2.063 0-.78-.302-1.513-.852-2.063L6.313.856A2.907 2.907 0 004.25 0a2.918 2.918 0 00-2.063.856A7.41 7.41 0 000 6.131a7.41 7.41 0 002.187 5.275l6.411 6.411A7.417 7.417 0 0013.873 20a7.407 7.407 0 005.27-2.183A2.9 2.9 0 0020 15.754c0-.78-.302-1.513-.852-2.063z",
    fill: "#666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.72156106e609ef768a72b25d1340a33b.svg";
export { ForwardRef as ReactComponent };